"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentDefinitionWithBoundariesSchema = void 0;
const zod_1 = require("zod");
const ComponentWithBoundaries_1 = require("./ComponentWithBoundaries");
exports.ComponentDefinitionWithBoundariesSchema = zod_1.z.object({
    component: ComponentWithBoundaries_1.ComponentWithBoundariesSchema,
});
//# sourceMappingURL=ComponentDefinitionWithBoundaries.js.map